import { render } from "./ContactGroup.vue?vue&type=template&id=468673ca"
import script from "./ContactGroup.vue?vue&type=script&lang=js"
export * from "./ContactGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__